import { z } from 'zod';

export const settingsContextSchema = z.object({
    useLinter: z.boolean(),
    editorFontSize: z.number(),
    fileBrowserFontSize: z.number(),
    terminalFontSize: z.number(),
    showFileBrowser: z.boolean(),
    // Since this data is persisted in localStorage, and these parameters were added after the initial
    // release, we have to mark them optional because they may be undefined for some users.
    saveBeforeRunning: z.boolean().optional(),
    showRawOutput: z.boolean().optional(),
    showDebugTools: z.boolean().optional(),
    fileBrowserFoldersFirst: z.boolean().optional(),
});

export type SettingsContext = z.infer<typeof settingsContextSchema>;
